import { SET_CURRENT_EXTERNAL_UNIT, SET_EXTERNAL_UNITS_LIST } from "./types";
import history from "../history";
import backend, { recursiveRequest } from "../apis/backend";
import errorHandler from "../helpers/errorHandler";
import store from "../store";

export const getExternalUnit = (externalUnitID) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/external-units/${externalUnitID}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            dispatch({ type: SET_CURRENT_EXTERNAL_UNIT, payload: response.data.externalUnit });
        };
    }
    catch (error) { errorHandler(error, null); }
};

export const getAllExternalUnits = () => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get("/api/external-units", {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            dispatch({ type: SET_EXTERNAL_UNITS_LIST, payload: response.data.externalUnits });
        };
    }
    catch (error) { errorHandler(error, null); }
};

export const newExternalUnit = (formValues, onFieldError) => async () => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.post(`/api/external-units`, formValues, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) history.push("/structure");
    }
    catch (error) { errorHandler(error, onFieldError); }
};

export const editExternalUnit = (externalUnitID, formValues, onFieldError) => async () => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.patch(`/api/external-units/${externalUnitID}`, formValues, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) history.push(`/structure/external/details/${externalUnitID}`);
    }
    catch (error) { errorHandler(error, onFieldError); }
};

export const editExternalUnitEmployees = (externalUnitID, formValues, onSuccess) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.patch(`/api/external-units/employees/${externalUnitID}`, formValues, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            dispatch({ type: SET_CURRENT_EXTERNAL_UNIT, payload: response.data.externalUnit });
            onSuccess();
        };
    }
    catch (error) { errorHandler(error, null); }
};

export const toggleExternalUnitActive = (externalUnitID) => async () => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.patch(`/api/external-units/active/${externalUnitID}`, {}, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) history.go(0);
    }
    catch (error) { errorHandler(error, null); }
};